import React, { useEffect, useRef } from 'react';

import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

export default function ConfirmationDialog(props) {

	let { title, prompt, yesCallback, noCallback, cancelCallback } = props;
	let closeCallback = cancelCallback ? cancelCallback : noCallback;
	
	const textRef = useRef();
	
	useEffect(() => {
		textRef.current.focus();
	}, []);

	return (
		<Dialog title={title} onClose={closeCallback}>
	    	<p
	        	style={{
	            	margin: "10px",
	              	textAlign: "center"
	            }}
	            tabIndex="0"
			>
	        	{prompt}
			</p>
	        <DialogActionsBar>
	        	{yesCallback && 
	        		<button
	            		className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
	              		onClick={yesCallback}
	            	>
	            		Yes
	            	</button>
	            }
	            {noCallback && 
	            	<button
	            		ref={textRef}
	            		className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
	            		onClick={noCallback}
	            	>
	            		No
	            	</button>
	            }
	            {cancelCallback && 
	            	<button
	            		className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
	            		onClick={cancelCallback}
	            	>
	             		Cancel
	            	</button>
	            }	            	
	        </DialogActionsBar>
		</Dialog>
	);
}